/*
 * Name: Featured Suppliers
 * Desc:
 *
 */
import React from "react"
import { Image } from "react-datocms"
import Link from "next/link"
import * as styles from "./FeaturedSuppliers.module.scss"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import noimage from "@images/noImage.png"

const FeaturedSuppliers = (props) => {
  const suppliers = props.suppliers.map((supplier, i) => {
    const price = supplier.pricerange ? ["£", "££", "£££", "££££"][supplier.pricerange - 1] : ""

    return (
      <div key={supplier.id}>
        <Link href={`/supplier/${supplier.slug}`}>
          <a className={styles.card}>
            {supplier.coverphoto ? (
              <Image data={supplier.coverphoto.responsiveImage} />
            ) : (
              <img src={noimage} alt="" />
            )}
            <div className={styles.info}>
              <span className={styles.title}>{supplier.name}</span>
              <span className={styles.category}>
                {supplier.supplierservices.length ? supplier.supplierservices[0].service : ""}
              </span>
              <span className={styles.price}>{price}</span>
            </div>
          </a>
        </Link>
      </div>
    )
  })

  return (
    <Section margin className={styles.FeaturedSuppliers}>
      <SiteWrapper textNarrow>
        <h2>{props.title}</h2>
        <div className={styles.grid}>{suppliers}</div>
      </SiteWrapper>
    </Section>
  )
}

export default FeaturedSuppliers
